module.exports = __webpack_public_path__ + "img/fde6460.png";